import { Resource as a, API as i } from "@coveo/platform-client";
const t = class t extends a {
  create(e) {
    return this.api.post(t.baseUrl, e);
  }
  delete(e) {
    return this.api.delete(`${t.baseUrl}/${e}`);
  }
  update(e, s) {
    return this.api.put(`${t.baseUrl}/${e}`, s);
  }
  get(e) {
    return this.api.get(`${t.baseUrl}/${e}`);
  }
  listNames(e) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/names`, e)
    );
  }
  listUrls(e) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/urls`, e)
    );
  }
};
t.baseUrl = `/rest/organizations/${i.orgPlaceholder}/commerce/private/listings`;
let r = t;
export {
  r as ListingPage
};
//# sourceMappingURL=ListingPage.js.map
